import React from 'react';
import { HowItWorksSection } from './how-it-works/how-it-works';
import { Box } from '@material-ui/core';
import { FreeTrial } from './free-trial/free-trial';
import { ShortDescription } from './short-description/short-description';
import { DiscountOffer } from './discount-offer/discount-offer';
import { MeetTrainers } from './meet-trainers/meet-trainers';

const HIDE_TRAINERS= true

const Sections = () => {
  return (
    <>
      <Box mx={2} mt={10.5}>
        <ShortDescription />
      </Box>
      <Box mt={10} />
      <HowItWorksSection />
      {!HIDE_TRAINERS &&(
          <>
            <Box mt={10} />
            <MeetTrainers />
          </>
        )
      }
      <Box mt={7} />
      <FreeTrial />
      <Box mt={7} />
      <DiscountOffer />
      <Box mt={10} />
    </>
  );
};

export default Sections;
